module.exports = __webpack_public_path__ + "54df9552a01fa641fb0df595cda30535.jpg";